/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function(window,document,$,L10n,undefined) {
	"use strict";

	function idSlctr(id) {
		return (0 !== id.indexOf('#') ? '#'+id : id);
	}

	function classSlctr(className) {
		return (0 !== className.indexOf('.') ? '.'+className : className);
	}

	function dataSlctr(data) {
		return (0 !== data.indexOf('[') ? '['+data+']' : data);
	}

	function hasClass(el, cls) {
		var cn;

		if (el.jquery) {
			return el.hasClass(cls);
		}

		if (!el.className.length) {
			return false;
		}

		cn = ' ' + el.className + ' ';
		cls = ' ' + cls + ' ';

		return (-1 !== cn.indexOf(cls));
	}

	function addClass(el, cls) {
		if (el.jquery) {
			el.addClass(cls);
			return el.attr('class');
		}

		if (!hasClass(el, cls)) {
			el.className += ' ' + cls;
		}

		return el.className;
	}

	function removeClass(el, cls) {
		if (el.jquery) {
			el.removeClass(cls);
			return el.attr('class');
		}

		if (hasClass(el, cls)) {
			el.className = $.trim( el.className.replace( new RegExp('\\b' + cls + '\\b', 'g') , '' ) );
		}

		return el.className;
	}

	var $window, $body, FixedNavbar,
		Cls, DataAttr, ProductPresentation, PPTab, $current, $currentContent;

	$window = $(window);
	$body = $('body');

	// fixed navbar
	FixedNavbar = function(selector) {
		var self = this;

		this.$navbar = $(selector);

		this.calculate();
		this._isSticky = ($window.scrollTop() >= this.distance);
		this.maybeChange();

		$window.on('resize', function() {
			self.calculate();
			self.maybeChange();
		})
		.scroll(function() {
			self.maybeChange();
		});
	};

	FixedNavbar.prototype.calculate = function() {
		this.distance = this.$navbar.offset().top;
	};

	FixedNavbar.prototype.shouldStick = function() {
		return ($window.scrollTop() >= this.distance);
	};

	FixedNavbar.prototype.maybeChange = function() {
		if (this.shouldStick()) {
			if (!this._isSticky) {
				this._makeSticky();
			}
		} else {
			if (this._isSticky) {
				this._unMakeSticky();
			}
		}
	};

	FixedNavbar.prototype._makeSticky = function() {
		this.$navbar.addClass('navbar-fixed-top');
		$body.css("padding-top", "70px");
		this._isSticky = true;
	};

	FixedNavbar.prototype._unMakeSticky = function() {
		this.$navbar.removeClass('navbar-fixed-top');
		$body.css("padding-top", "0px");
		this._isSticky = false;
	};

	// product tabs
	Cls = {
		tab:                'mm-pp-tab',
		currentTab:         'mm-current-tab',
		currentTabContent:  'mm-current-tab-content',
		currentTabItem:     'mm-current-tab-item',
		currentList:        'mm-current-list',
		initialized:        'mm-tabs-initialized',
		backBtn:            'mm-back-button',
		videoVisible:       'mm-show-video',
		elementHidden:      'mm-element-hidden',
		packageInfo:        'mm-product-package-info',
		moreInfoOpened:     'mm-info-opened',
		productBox:         'mm-product-box',
		showBoxDetails:     'mm-show-details',
		video:              'mm-video',
		modalMinHeight:     'mm-min-height-modal',
		modalBody:          'modal-body',
	};

	DataAttr = {
		pp:           'data-product-presentation',
		tab:          'data-pp-tab',
		firstTab:     'data-pp-first-tab',
		detailsTab:   'data-pp-detail-tab',
		content:      'data-pp-content',
		illustration: 'data-pp-illustration',
		video:        'data-pp-video',
		tabItem:      'data-tab-item',
		features:     'data-pp-features',
		description:  'data-pp-description',
		more:         'data-pp-more',
		design:       'data-pp-design',
		moreInfo:     'data-more-info',
	};

	ProductPresentation = function(el) {
		this.$el = el.jquery ? el : $(el);

		this.$content = $(dataSlctr(DataAttr.content), this.$el);

		// zakładki
		this.tabs = [];

		this.initialize();
	};

	ProductPresentation.prototype.initialize = function() {
		var self = this;

		// tylko raz
		if (this.tabs.length) {
			return;
		}

		$(dataSlctr(DataAttr.tab), this.$el).each(function(){
			self.tabs.push(new PPTab(this, self.$el));
		});

		// zdarzenia:
		// tabs - wybranie
		this.$el.on('tab-selected', function(e) {
			var i;

			for (i = 0; i < self.tabs.length; i++) {
				if (self.tabs[i] !== e.tab) {
					self.tabs[i].deselect();
				}
			}

			if ($window.scrollTop() > e.tab.getTab().offset().top) {
				$('html,body').animate({
					scrollTop: e.tab.getTab().offset().top - 40
				}, 600);
			}
		})
		.on('closed-tab', function(e) {
			var i;

			for (i = 0; i < self.tabs.length; i++) {
				if (self.tabs[i] !== e.tab && !self.tabs[i].getSelector()) {
					self.tabs[i].select();
					break;
				}
			}
		});
	};

	ProductPresentation.prototype.selectTab = function(id) {
		var tabs, i;

		id = (0 === id.indexOf('#') ? id.substr(1) : id);

		tabs = $.grep(this.tabs, function(tab) {
			return tab.getTab().attr('id') === id;
		});

		if (tabs.length) {
				
			for (i =0; i < this.tabs.length; i++) {
				if (this.tabs[i].getTab().attr('id') === id) {
					this.tabs[i].select();
				} else {
					this.tabs[i].deselect();
				}
			}
	
		}
	};

	// argument: element będący zakładką, przełącznik znajdzie się sam
	PPTab = function(el, ppEl) {
		this.$pp = ppEl.jquery ? ppEl : $(ppEl);

		this.$tab = el.jquery ? el : $(el);

		if (this.$tab.attr('id')) {
			this.$selector = $(dataSlctr(DataAttr.tabItem), this.$el).children('a[href*="'+idSlctr(this.$tab.attr('id'))+'"]').parent();
		} else {
			this.$selector = false;
		}

		// cechy
		this.features = {
			$items:   $(dataSlctr(DataAttr.features), this.$tab),
			$current: $(classSlctr(Cls.currentList), this.$tab)
		};

		// przyciski meta
		this.meta = {
			$lm:   $(dataSlctr(DataAttr.more), this.$tab), // "learn more"
			$dsgn: $(dataSlctr(DataAttr.design), this.$tab) // "design"
		};

		this.initialize();
	};

	PPTab.prototype.initialize = function() {
		var self = this;

		if (this.$selector) {
			this.$selector.on('click', function(e){
				if (!hasClass(this,Cls.currentTabItem)) {
					self.select();
					self.$pp.trigger($.Event('tab-selected', {tab: self}));
				}

				e.preventDefault();
			});

			$('<button type="button" class="close" aria-label="' + L10n.close + '"><span aria-hidden="true">&times;</span></button>').on('click', function(e){
				self.deselect();
				self.$pp.trigger($.Event('closed-tab', {tab: self}));
			}).prependTo(this.$tab.find(dataSlctr(DataAttr.description)));
		}

		if (this.features.$items.length) {
			if (!this.features.$current.length) {
				this.features.$current = this.features.$items.first().addClass(Cls.currentList);
			}
		}

		if (this.meta.$lm.length) {
			// meta - click: learn more
			this.meta.$lm.on('click', function(e){
				var $nextList = self.features.$current.next(dataSlctr(DataAttr.features));

				if (!$nextList.length) {
					$nextList = self.features.$items.first();
					this.innerHTML = L10n.more;
					removeClass(this, Cls.backBtn);
				} else {
					this.innerHTML = L10n.back;
					addClass(this, Cls.backBtn);
				}

				self.features.$current.removeClass(Cls.currentList);
				self.features.$current = $nextList.addClass(Cls.currentList);

				e.preventDefault();
			});
		}

		if (this.meta.$dsgn.length) {
			// meta - click: design
		//	this.meta.$dsgn.on('click', function(e) {
		//		$(dataSlctr(DataAttr.illustration), self.$tab).add(dataSlctr(DataAttr.description, self.$tab)).toggleClass(Cls.elementHidden);
		//		$(dataSlctr(DataAttr.video), self.$tab).toggleClass(Cls.videoVisible);
		//		e.preventDefault();
		//	});
		}
	};

	PPTab.prototype.getTab = function() {
		return this.$tab;
	};

	PPTab.prototype.getSelector = function() {
		return this.$selector;
	};

	PPTab.prototype.select = function() {
		this.$tab.addClass(Cls.currentTab);

		if (this.$selector) {
			this.$selector.addClass(Cls.currentTabItem);
		}
	};

	PPTab.prototype.deselect = function() {
		this.$tab.removeClass(Cls.currentTab);

		if (this.$selector) {
			this.$selector.removeClass(Cls.currentTabItem);
		}
	};

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
		var navbar = new FixedNavbar('#main-nav');

		addClass(document.documentElement, 'js');

		$(document).on('show.bs.modal', function(e) {
			$(e.target).find(classSlctr(Cls.video)).hide();
		}).on('shown.bs.modal', function(e) {
			var $v = $(e.target).find(classSlctr(Cls.video)).find('video');

			$(e.target).find(classSlctr(Cls.video)).show().slideDown();

			if ($v.length) {
				$v.get(0).player.play();
			}

			$window.trigger('resize');
		}).on('hide.bs.modal', function(e) {
			var $v = $(e.target).find(classSlctr(Cls.video)).find('video');

			if ($v.length) {
				$v.get(0).player.pause();
			}
		});

		// scrollTop
		$('#main-nav .menu-item a').on('click', function(e) {
			var $t;

			if (-1 !== this.href.indexOf('#')) {
				$t = $(this.href.substr(this.href.indexOf('#')));

				if (!$t.length) {
					return;
				}

				e.preventDefault();

				$('html,body').animate({
					scrollTop: $t.offset().top - 50
				}, 800, 'swing');
			}
		});
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
		$(dataSlctr(DataAttr.pp)).each(function(){
			$.data(this, 'productPresentation', new ProductPresentation(this));
		});

		$(dataSlctr(DataAttr.moreInfo)).on('click', function(e){
			var $this = $(this), $c;

			$c = $this.closest(classSlctr(Cls.packageInfo)).children(classSlctr(Cls.productBox));
			$this.toggleClass(Cls.moreInfoOpened);
			$c.toggleClass(Cls.showBoxDetails);

			if ($c.hasClass(Cls.showBoxDetails)) {
				$this.html(L10n.back);
			} else {
				$this.html(L10n.more_info);
			}

			e.preventDefault();
		});

		// home link
		$('[data-home-link]').on('click', function(e) {
			e.preventDefault();

			$('html,body').animate({
				scrollTop: 0
			}, 800, 'swing');
		});
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(window,document,window.jQuery,AppL10n); // Fully reference jQuery after this point.
